import React from "react";

import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";
import "./EthicsBanner.css";

const EthicsBanner = () => (
    <WidgetContainer stylesClass="ethics-banner">
        <div className="ethics-banner-content" title="PhonePe Ethics">
            <h2>
                Read more about <br /> the PhonePe Ethics
            </h2>
            <a
                href="https://www.phonepeethics.com/content/phonepe-ethics/en_us.html"
                target="_blank"
            >
                <span className="ethics-button">Learn More</span>
            </a>
        </div>
    </WidgetContainer>
);

export default EthicsBanner;
